export default class CountrySelector {
  constructor(countrySelect, provinceSelect) {
    this.countrySelect = countrySelect;
    this.provinceSelect = provinceSelect;

    if (this.countrySelect && this.provinceSelect) {
      this._attachListeners();
      this._initSelectors();
    }
  }

  destroy() {
    if (this.countrySelect) {
      this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
    }
  }
  _initSelectors() {
    // Check first the default value of country
    var defaultCountry = this.countrySelect.getAttribute('data-default');

    if (defaultCountry) {
      for (var i = 0; i !== this.countrySelect.options.length; ++i) {
        if (this.countrySelect.options[i].text === defaultCountry) {
          this.countrySelect.selectedIndex = i;
          break;
        }
      }
    } else {
      this.countrySelect.selectedIndex = 0;
    }

    var event = new Event('change', { bubbles: true });
    this.countrySelect.dispatchEvent(event);

    // Then the province
    var defaultProvince = this.provinceSelect.getAttribute('data-default');

    if (defaultProvince) {
      this.provinceSelect.value = defaultProvince;
    }
  }
  _attachListeners() {
    this._onCountryChangedListener = this._onCountryChanged.bind(this);
    this.countrySelect.addEventListener('change', this._onCountryChangedListener);
  }
  _onCountryChanged() {
    var _this9 = this;

    var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
        provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');

    // First remove all options
    this.provinceSelect.innerHTML = '';

    if (provinces.length === 0) {
      this.provinceSelect.parentNode.style.display = 'none';
      return;
    }

    // We need to build the provinces array
    provinces.forEach(function (data) {
      _this9.provinceSelect.options.add(new Option(data[1], data[0]));
    });

    this.provinceSelect.parentNode.style.display = 'block';
  }
}